module.exports = __webpack_public_path__ + "assets/img/btn-detail-35fdf227.png";